import { render, staticRenderFns } from "./Covid-19.vue?vue&type=template&id=0ec3f678&"
import script from "./Covid-19.vue?vue&type=script&lang=js&"
export * from "./Covid-19.vue?vue&type=script&lang=js&"
import style0 from "./Covid-19.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports